export const getCalculateProgressParams = (
  requiredFieldsValues: any[]
): [number, number] => {
  let validFields = 0;
  let totalFields = requiredFieldsValues.length;
  requiredFieldsValues.forEach((value) => {
    if (value?.toString().trim()) validFields++;
  });

  return [validFields, totalFields];
};
